import { useAsyncExecutor, useAsyncExecutor2 } from "async-executor-hook";
import { useEffect, useState } from "react";
import { getErrorValueResponse } from "../../common/error/Error";

import { HTTP_METHODS, PaymentModalStates } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import CollectionMethod from "../CollectionMethod/CollectionMethod";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import { ConfirmationModalThird } from "../ConfirmationModal/ConfirmationModalThird";
import ContadoConfirmation from "../ContadoConfirmation/ContadoConfirmation";
import ContadoMethodAddNewVoucher from "../ContadoMethod/ContadoMethodAddNewVoucher";
import ContadoMethodPayment from "../ContadoMethod/ContadoMethodPayment";
import CreditMethod from "../CreditMethod/CreditMethod";
import Modal from "../Modal/Modal";
import { paymentConvertResponse } from "../Payment/common";
import PaymentMethod from "../PaymentMethod/PaymentMethod";
function PaymentModal(props) {
  const {
    toggleModal,
    invoices,
    hideModalPaymentType,
    hideModalPaymentTypeShowModal,
    setShowModalError1,
    updateMessageError1,
    setMessageSuccessCreditMethod,
    setModalSuccessCreditMethod,
    setShowModalUpfront,
    setMessageErrorUpfront,
    updateShowModal,
    setShowModalThirdError,
    setMessageErrorThird,
    setShowModalThirdSuccess,
    showModalSelectInvoice,
    setShowModalSuccessContadoMethod,
    setShowModalErrorContadoMethod,
    setShoModalMessageContadoMethod,
    countPageRedirect,
    closeModal,
    dateUrlQuotationQuoted,
    onErrorQuoted,
    clearShoppingCar,
  } = props;
  const [paymentState, updatePaymentState] = useState(
    PaymentModalStates.CHOOSE_PAYMENT_METHOD
  );
  const [totalAmount, updateTotalAmount] = useState<any>(0);
  const [payerItems, updatePayerItems] = useState([]);

  const [dataCode, updateDataCode] = useState();
  const [messageError, updateMessageError] = useState("");

  const [showModalError, updateShowModalError] = useState(false);

  const toggleGetModal = () => {
    updateShowModalError(!showModalError);
  };

  useEffect(() => {
    let totalAmount = { usd: 0, pen: 0 };
    for (const invoice of invoices) {
      totalAmount.pen += Number(invoice.amount.pen);
      totalAmount.usd += Number(invoice.amount.usd);
    }
    updateTotalAmount(totalAmount);
  }, [invoices]);

  const onClose = (refreshNeeded) => {
    if (props.toggleModal != null) {
      props.toggleModal(refreshNeeded);
    }
  };
  const checkIfPaymentStateIsBank = (paymentState) => {
    return (
      paymentState === PaymentModalStates.BCP ||
      paymentState === PaymentModalStates.BBVA ||
      paymentState === PaymentModalStates.INTERBANK ||
      paymentState === PaymentModalStates.SCOTIABANK ||
      paymentState === PaymentModalStates.BANKNATION
    );
  };

  const loadUpfrontManual = useAsyncExecutor(
    (params: any) => {
      const { quotation_ids } = params;
      return networkBackendRequest(
        `/invoices/estimate/upfront-manual/`,
        HTTP_METHODS.GET,
        {
          payment_type_option: "upfront_manual",
          quotation_ids: quotation_ids,
        }
      ).then((response) => response.json());
    },
    {
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        updateMessageError(errorMessage);
        toggleGetModal();
      },
    }
  );

  const [volateQuoted, setVolateQuoted] = useState<[]>([]);
  const [quotation_ids, setQuotation_ids] = useState<[]>([]);

  const getQuotationQuotedVolantes: any = useAsyncExecutor2(
    (params: any) => {
      const { invoices } = params;
      const volante_nums = invoices.map((volante) => volante.volanteId);
      return networkBackendRequest("/quotations/quoted/", HTTP_METHODS.GET, {
        volante_nums,
        page_size: volante_nums.length,
      })
        .then((resp) => resp.json())
        .then(paymentConvertResponse);
    },
    {
      onSuccess: (data, params) => {
        const { details, quotation_ids } = data;
        const { invoices } = params;
        if (invoices.length === quotation_ids.length) {
          setVolateQuoted(details);
          setQuotation_ids(quotation_ids);
        } else {
          onErrorQuoted(
            "Alguno de los volantes ya fueron facturados. Agradeceremos contactarse con el equipo de Soporte Talmaclick."
          );
        }
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        onErrorQuoted(errorMessage);
      },
    }
  );

  const loadUpfront = useAsyncExecutor(
    (params: any) => {
      const { quotation_ids } = params;
      return networkBackendRequest(
        `/invoices/estimate/upfront/`,
        HTTP_METHODS.GET,
        {
          payment_type_option: "upfront",
          quotation_ids: quotation_ids,
        }
      ).then((response) => response.json());
    },
    {
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        updateMessageError(errorMessage);
        toggleGetModal();
      },
    }
  );

  const [showModalContadoInformation, setShowModalContadoInformation] =
    useState(false);
  const [showModalConfirmation, setShowModalConfirmation] = useState(false);
  const [showModalNewVoucher, setShowModalNewVoucher] = useState(false);
  const [showModalImportantVoucher, setShowModalImportantVoucher] =
    useState(false);
  const [dataComprobantes, setDataComprobantes] = useState([]);

  const [dataComprobantesTest, setDataComprobantesTest] = useState([]);
  const removeComprobante = (data_voucher) => {
    const newComprobanteTest = dataComprobantes.filter(
      (_, index) => index !== data_voucher
    );
    setDataComprobantes(newComprobanteTest);
  };

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectMyFile, setSelectMyFile] = useState([]);

  const onFileChange = (files) => {
    setSelectedFiles(files);
    setSelectMyFile(files);
  };
  const [redirectRecaudo, setRedirectRecaudo] = useState(0);
  return (
    <>
      {showModalContadoInformation && (
        <ConfirmationModalThird
          onAccept={() => {
            setShowModalContadoInformation(false);
            setShowModalConfirmation(true);
          }}
          title={`Importante pago al contado`}
          toggleModal={() => {
            setShowModalContadoInformation(false);
            setShowModalConfirmation(true);
          }}
          buttonTitle={"Cerrar"}
          backgroundColor={"#88B13B"}
        >
          <p>
            Al realizar el pago al contado, por favor abonar el monto según lo
            indicado por el sistema.
          </p>
          <p>
            Es recomendable no abonar más o menos para evitar posibles
            reprocesos.{" "}
          </p>
          <p>Gracias por su comprensión.</p>
        </ConfirmationModalThird>
      )}
      {showModalImportantVoucher && (
        <ConfirmationModalThird
          onAccept={() => {
            setShowModalImportantVoucher(false);
            setShowModalConfirmation(true);
            setShowModalNewVoucher(true);
          }}
          title={`Importante comprobantes`}
          toggleModal={() => {
            setShowModalImportantVoucher(false);
            setShowModalConfirmation(true);
            setShowModalNewVoucher(true);
          }}
          buttonTitle={"Cerrar"}
          backgroundColor={"#88B13B"}
        >
          <p>
            Se le recuerda que lo depositado debe cubrir el valor de la
            facturación.
          </p>
          <p>
            Evitar en lo posible adjuntar comprobantes que tengan un monto mayor
            o menor para evitar posibles reprocesos.
          </p>
          <p>Gracias por su comprensión.</p>
        </ConfirmationModalThird>
      )}
      {showModalConfirmation && (
        <Modal
          onOutsideClick={() => {
            const refreshNeeded = checkIfPaymentStateIsBank(paymentState);
            onClose(refreshNeeded);
          }}
        >
          <ContadoMethodPayment
            totalAmount={totalAmount}
            invoices={invoices}
            loadUpfrontManual={loadUpfrontManual}
            setShowModalConfirmation={setShowModalConfirmation}
            setShowModalImportantVoucher={setShowModalImportantVoucher}
            updateShowModal={updateShowModal}
            setShowModalSuccessContadoMethod={setShowModalSuccessContadoMethod}
            setShowModalErrorContadoMethod={setShowModalErrorContadoMethod}
            setShoModalMessageContadoMethod={setShoModalMessageContadoMethod}
            dataComprobantes={dataComprobantes}
            removeComprobante={removeComprobante}
            selectedFiles={selectedFiles}
            selectMyFile={selectMyFile}
            dataComprobantesTest={dataComprobantesTest}
            countPageRedirect={countPageRedirect}
            dateUrlQuotationQuoted={dateUrlQuotationQuoted}
            volateQuoted={volateQuoted}
            quotation_ids={quotation_ids}
            getQuotationQuotedVolantes={getQuotationQuotedVolantes}
            clearShoppingCar={clearShoppingCar}
          />
        </Modal>
      )}
      {showModalNewVoucher && (
        <Modal
          onOutsideClick={() => {
            setShowModalNewVoucher(false);
            setShowModalConfirmation(true);
          }}
        >
          <ContadoMethodAddNewVoucher
            loadUpfrontManual={loadUpfrontManual}
            closeModalNewVoucher={() => {
              setShowModalNewVoucher(false);
              setShowModalConfirmation(true);
            }}
            setShowModalErrorContadoMethod={setShowModalErrorContadoMethod}
            setShoModalMessageContadoMethod={setShoModalMessageContadoMethod}
            onSuccessData={(resp) => {
              const { data, params } = resp;
              setDataComprobantes((c) => [data, ...c]);
              setDataComprobantesTest((a) => [params, ...a]);
            }}
            updateShowModal={updateShowModal}
            selectedFiles={selectedFiles}
            selectMyFile={selectMyFile}
            onFileChange={onFileChange}
            setSelectedFiles={setSelectedFiles}
            setSelectMyFile={setSelectMyFile}
          />
        </Modal>
      )}
      {paymentState === PaymentModalStates.CREDIT_METHOD && (
        <Modal
          onOutsideClick={() => {
            const refreshNeeded = checkIfPaymentStateIsBank(paymentState);
            onClose(refreshNeeded);
          }}
        >
          <CreditMethod
            totalAmount={totalAmount}
            toggleModal={onClose}
            invoices={invoices}
            payerItems={payerItems}
            hideModalPaymentType={hideModalPaymentType}
            hideModalPaymentTypeShowModal={hideModalPaymentTypeShowModal}
            updateMessageError1={updateMessageError1}
            setShowModalError1={setShowModalError1}
            setMessageSuccessCreditMethod={setMessageSuccessCreditMethod}
            setModalSuccessCreditMethod={setModalSuccessCreditMethod}
            setShowModalThirdError={setShowModalThirdError}
            setMessageErrorThird={setMessageErrorThird}
            updateShowModal={updateShowModal}
            setShowModalThirdSuccess={setShowModalThirdSuccess}
            countPageRedirect={countPageRedirect}
            dateUrlQuotationQuoted={dateUrlQuotationQuoted}
            closeModal={closeModal}
            getQuotationQuotedVolantes={getQuotationQuotedVolantes}
            volateQuoted={volateQuoted}
            quotation_ids={quotation_ids}
            clearShoppingCar={clearShoppingCar}
          />
        </Modal>
      )}
      {paymentState === PaymentModalStates.COLLECTION_PAYMENT_METHOD && (
        <Modal
          onOutsideClick={() => {
            const refreshNeeded = checkIfPaymentStateIsBank(paymentState);
            onClose(refreshNeeded);
          }}
        >
          <CollectionMethod
            totalAmount={totalAmount}
            updatePaymentState={updatePaymentState}
            updateDataCode={updateDataCode}
            loadUpfront={loadUpfront}
            setShowModalUpfront={setShowModalUpfront}
            setMessageErrorUpfront={setMessageErrorUpfront}
            updateShowModal={updateShowModal}
            countPageRedirect={countPageRedirect}
            onCountRedirect={(data) => {
              setRedirectRecaudo(data);
            }}
            dateUrlQuotationQuoted={dateUrlQuotationQuoted}
            getQuotationQuotedVolantes={getQuotationQuotedVolantes}
            volateQuoted={volateQuoted}
            quotation_ids={quotation_ids}
            clearShoppingCar={clearShoppingCar}
          />
        </Modal>
      )}

      {showModalError && messageError && (
        <ConfirmationModal
          message={messageError}
          onAccept={() => {
            toggleGetModal();
          }}
          title={`Atención`}
          toggleModal={() => {
            toggleGetModal();
          }}
        />
      )}

      {showModalSelectInvoice && (
        <Modal
          onOutsideClick={() => {
            const refreshNeeded = checkIfPaymentStateIsBank(paymentState);
            onClose(refreshNeeded);
          }}
        >
          {paymentState === PaymentModalStates.CHOOSE_PAYMENT_METHOD ? (
            <PaymentMethod
              totalAmount={totalAmount}
              updatePaymentState={updatePaymentState}
              updatePayerItems={updatePayerItems}
              invoices={invoices}
              loadUpfrontManual={loadUpfrontManual}
              loadUpfront={loadUpfront}
              toggleModal={onClose}
              setShowModalContadoInformation={setShowModalContadoInformation}
              getQuotationQuotedVolantes={getQuotationQuotedVolantes}
            />
          ) : null}

          {checkIfPaymentStateIsBank(paymentState) ? (
            <ContadoConfirmation
              toggleModal={toggleModal}
              paymentState={paymentState}
              dataCode={dataCode}
              closeModal={closeModal}
              redirectRecaudo={redirectRecaudo}
            />
          ) : null}
        </Modal>
      )}
    </>
  );
}

export default PaymentModal;
